export default "https://cdn-static.gokick.com/assets/6e728f413af15b4cc1be7e84aa96f9132e166160/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";